// extracted by mini-css-extract-plugin
export default {"cls1":"VeloRadioTileGroup-Label_cls1__ddN4Y","cls2":"VeloRadioTileGroup-Label_cls2__Dg0aj VeloRadioTileGroup-Label_cls1__ddN4Y"};